export { default } from './Heading';
export * from './Heading';
